import React, { Component } from "react";
import { connect } from "react-redux";

import "./style.scss";

import Tubes from "./img/results-tubes-210.svg";
import Tube1 from "./img/210-result-1.svg";
import Tube2 from "./img/210-result-2.svg";
import Tube3 from "./img/210-result-3.svg";

import bp754 from "./img/plasmid-results/754_bp.svg";
import bp807 from "./img/plasmid-results/807_bp.svg";
import bp1184 from "./img/plasmid-results/1184_bp.svg";
import bp1614 from "./img/plasmid-results/1614_bp.svg";
// import bp4705 from './img/plasmid-results/4705_bp.svg';
import bp5082 from "./img/plasmid-results/5082_bp.svg";
import bp8990 from "./img/plasmid-results/8990_bp.svg";
import bp9200 from "./img/plasmid-results/9200_bp.svg";
import bp9410 from "./img/plasmid-results/9410_bp.svg";
import para4872bp from "./img/plasmid-results/para_4872_bp.svg";
import paraR5302 from "./img/plasmid-results/para_r_5302_bp.svg";
import paraR377bp from "./img/plasmid-results/para_r_377_bp.svg";
import paraR4495bp from "./img/plasmid-results/para_r_4495_bp.svg";
import paraR4705bp from "./img/plasmid-results/4705_bp.svg";
import pkanR5512bp from "./img/plasmid-results/pkan_r_5512_bp.svg";
import blank from "./img/plasmid-results/blank-prediction.svg";

const images = {
  754: bp754,
  807: bp807,
  1184: bp1184,
  1614: bp1614,
  // '4705': bp4705,
  5082: bp5082,
  8990: bp8990,
  9200: bp9200,
  9410: bp9410,
  4872: para4872bp,
  5302: paraR5302,
  377: paraR377bp,
  4495: paraR4495bp,
  4705: paraR4705bp,
  5512: pkanR5512bp,
  blank: blank,
};

class PredictionResults37 extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  sumArr = (arr) => {
    return (
      parseInt(!isNaN(arr[0]) ? arr[0] : 0) +
      parseInt(!isNaN(arr[1]) ? arr[1] : 0)
    );
  };

  buildPredictionResults = () => {
    let imgs = ["", "", ""];
    imgs[0] = images[this.sumArr(this.props.predictedFragments.p_ARA_R) + ""];
    imgs[1] = images[this.sumArr(this.props.predictedFragments.plasm_2) + ""];
    imgs[2] = images[this.sumArr(this.props.predictedFragments.plasm_3) + ""];

    //TODO: Add blank result for placeholder - use 754 BP with different text

    return (
      <div>
        {this.sumArr(this.props.predictedFragments.p_ARA_R) === 0 ? (
          <img
            className="result-plasmid-img"
            src={images["blank"]}
            alt={"No prediction."}
          />
        ) : (
          <img
            className={
              "result-plasmid-img" +
              (this.props.predictedFragments.p_ARA_R[1] > 0
                ? " plasmid"
                : " single-fragment")
            }
            src={imgs[0]}
            alt={"p ARA R"}
          />
        )}
        {this.sumArr(this.props.predictedFragments.plasm_2) === 0 ? (
          <img
            className="result-plasmid-img"
            src={images["blank"]}
            alt={"No prediction."}
          />
        ) : (
          <img
            className={
              "result-plasmid-img" +
              (this.props.predictedFragments.plasm_2[1] > 0
                ? " plasmid"
                : " single-fragment")
            }
            src={imgs[1]}
            alt={"Plasmid 2"}
          />
        )}
        {this.sumArr(this.props.predictedFragments.plasm_3) === 0 ? (
          <img
            className="result-plasmid-img"
            src={images["blank"]}
            alt={"No prediction."}
          />
        ) : (
          <img
            className={
              "result-plasmid-img" +
              (this.props.predictedFragments.plasm_3[1] > 0
                ? " plasmid"
                : " single-fragment")
            }
            src={imgs[2]}
            alt={"Plasmid 3"}
          />
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "595px",
            pointerEvents: "none",
            marginTop: "-105px",
            marginLeft: "50px",
          }}
        >
          {this.sumArr(this.props.predictedFragments.p_ARA_R) === 0 ? (
            <p id="results-plasmid-text-none-1" className="result-plasmid-text">
              {"No prediction"}
            </p>
          ) : (
            <p id="results-plasmid-text-1" className="result-plasmid-text">
              {this.sumArr(this.props.predictedFragments.p_ARA_R) + " bp"}
            </p>
          )}
          {this.sumArr(this.props.predictedFragments.plasm_2) === 0 ? (
            <p id="results-plasmid-text-none-2" className="result-plasmid-text">
              {"No prediction"}
            </p>
          ) : (
            <p id="results-plasmid-text-2" className="result-plasmid-text">
              {this.sumArr(this.props.predictedFragments.plasm_2) + " bp"}
            </p>
          )}
          {this.sumArr(this.props.predictedFragments.plasm_3) === 0 ? (
            <p id="results-plasmid-text-none-3" className="result-plasmid-text">
              {"No prediction"}
            </p>
          ) : (
            <p id="results-plasmid-text-3" className="result-plasmid-text">
              {this.sumArr(this.props.predictedFragments.plasm_3) + " bp"}
            </p>
          )}
        </div>
      </div>
    );
  };

  getResult = () => {
    let fragments = false;
    let plasmid = false;

    if (
      this.props.solutions.hasOwnProperty("K+") ||
      this.props.solutions.hasOwnProperty("A+")
    ) {
      fragments = true;
    }

    if (
      this.props.solutions.hasOwnProperty("5XB") &&
      this.props.solutions.hasOwnProperty("A+") &&
      this.props.solutions.hasOwnProperty("K+")
    ) {
      plasmid = true;
    }

    return !fragments ? Tube1 : !plasmid ? Tube2 : Tube3;
  };

  getResultText = () => {
    let fragments = false;
    let plasmid = false;

    if (
      this.props.solutions.hasOwnProperty("K+") ||
      this.props.solutions.hasOwnProperty("A+")
    ) {
      fragments = true;
    }

    if (
      this.props.solutions.hasOwnProperty("5XB") &&
      this.props.solutions.hasOwnProperty("A+") &&
      this.props.solutions.hasOwnProperty("K+")
    ) {
      plasmid = true;
    }

    return !fragments ? "Failed" : !plasmid ? "Failed" : "Succeeded";
  };

  render() {
    return (
      <div className="graphics">
        <div style={{ display: "flex" }}>
          <h5 className="header" tabIndex={0}>
            {"Actual results"}
          </h5>
          <h5 className="header" tabIndex={0}>
            {"Ideal results"}
          </h5>
        </div>
        <div style={{ position: "relative" }}>
          <img
            className="result-bg"
            src={Tubes}
            alt={
              "An image depicting an unsucessful result and a successful result"
            }
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              pointerEvents: "none",
              marginTop: "-24px",
            }}
          />
          <img
            className="result-tube"
            tabIndex={0}
            src={this.getResult()}
            alt={"Tube showing a " + this.getResultText() + " reaction."}
            style={{
              position: "absolute",
              pointerEvents: "none",
              top: "27%",
              left: "calc(25% + 8px)",
              transform: "translate(-50%, 0)",
            }}
          />
          <div
            tabIndex={0}
            aria-label={"Tube showing a successful reaction."}
            style={{
              width: "161px",
              height: "296px",
              position: "absolute",
              pointerEvents: "none",
              top: "27%",
              left: "calc(70% + 16px)",
              transform: "translate(-50%, 0)",
            }}
          ></div>
          <div
            style={{
              width: "100%",
              height: "100%",
              top: "55px",
              position: "absolute",
              marginTop: "0px",
            }}
          >
            <div
              aria-label=""
              style={{
                position: "absolute",
                top: "20px",
                left: 0,
                width: "50%",
                height: "100%",
              }}
            >
              <p
                className="tubeResultsFailedText"
                style={{ textAlign: "center", color: "white" }}
              >
                {/* this.getResultText() */}
              </p>
            </div>
            <div
              aria-label=""
              style={{
                position: "absolute",
                top: "20px",
                right: 0,
                width: "50%",
                height: "100%",
              }}
            >
              {/* <p className="tubeResultsFailedText" style={{textAlign: 'center', color: 'white'}}>Succeeded</p> */}
            </div>
          </div>
        </div>
        <div>
          <h5
            tabIndex={0}
            style={{
              fontSize: "18px",
              fontWeight: 700,
            }}
          >
            {"Your predicted plasmids"}
          </h5>
        </div>
        <div
          className="predictedBox"
          tabIndex={0}
          aria-label={
            "Predicted results. Your predicted recombinant plasmids made of" +
            " " +
            (this.props.predictedFragments.p_ARA_R[0] +
              this.props.predictedFragments.p_ARA_R[1]) +
            " bp, " +
            (this.props.predictedFragments.plasm_2[0] +
              this.props.predictedFragments.plasm_2[1]) +
            " bp, " +
            (this.props.predictedFragments.plasm_3[0] +
              this.props.predictedFragments.plasm_3[1]) +
            " bp"
          }
        >
          {this.buildPredictionResults()}
        </div>
        <br />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    id: ownProps.id,
    predictedFragments: state.predictions.fragments,
    // TODO: following will be coming from the protocol state
    solutions: {},
  };
};

export default connect(mapStateToProps)(PredictionResults37);
